import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFixedWidth20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFixedWidth20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.002 4.7a.75.75 0 0 0-1.5 0v10.6a.75.75 0 0 0 1.5 0zM2.75 3.95a.75.75 0 0 1 .75.75v10.6a.75.75 0 0 1-1.5 0V4.7a.75.75 0 0 1 .75-.75M14 10a.75.75 0 0 1-.75.75h-6.5a.75.75 0 1 1 0-1.5h6.5A.75.75 0 0 1 14 10"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFixedWidth20);
